import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import FilterBar from '../FilterBar';
import DataTableView from './DataTableView';
import { clearErrorMessage } from '../../actions';
import table_styles from '../../css/table.css';

const customStyles = {
  overlay: {
    zIndex                : '10000000'
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};


class TableViewComp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      modalMessage: ''
    }

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

  }

  componentWillMount() {
    this.setState({"navBarHeight": table_styles.navHeight})
    this.setState({"height":window.innerHeight - table_styles.navHeight})
    this.setState({"width":window.innerWidth})
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.errorMessage) {
      this.setState({modalMessage: nextProps.errorMessage });
      this.setState({modalIsOpen: true});
    }
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    this.subtitle.style.color = '#222';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
    this.props.dispatch(clearErrorMessage())
  }

  render() {
    return(
      <div>
        <ReactModal isOpen={this.state.modalIsOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.closeModal} style={customStyles} contentLabel="Query Name Modal">
          <h4 ref={subtitle => this.subtitle = subtitle}>{this.state.modalMessage}</h4>
          <button className="btn btn-info center-block" onClick={this.closeModal}>Okay</button>
        </ReactModal>
        <div style={{float: 'left'}}>
          <div className='col-md-12' style={{height: table_styles.topSpace + 'px'}}>
            <div className='col-sm-3 pull-left' style={{paddingTop: '15px'}}>
              <h3>Filters</h3>
            </div>
          </div>
          <div style={{float: 'left', height: this.state.height - table_styles.topSpace, overflowY: 'auto'}}>
            <FilterBar width={table_styles.filtersWidth} margin={table_styles.filtersMarginLeft}/>
          </div>
        </div>
        <div style={{overflowX: 'auto', paddingLeft: '15px'}}>
          <DataTableView />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.TableApp.get('errorMessage'),
    template:state.Template
  }
}

const TableView = connect(mapStateToProps)(TableViewComp)

export default TableView;



// WEBPACK FOOTER //
// ./src/components/TableView/index.js